module.exports = __webpack_public_path__ + "img/thumbnail_NileLechwe_j_normal.b308df9e.png";